/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isprivate1Inputs */

const en_entity_isprivate1 = /** @type {(inputs: Entity_Isprivate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Private`)
};

const de_entity_isprivate1 = /** @type {(inputs: Entity_Isprivate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist privat`)
};

/**
* | output |
* | --- |
* | "Is Private" |
*
* @param {Entity_Isprivate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isprivate1 = /** @type {((inputs?: Entity_Isprivate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isprivate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isprivate1(inputs)
	return de_entity_isprivate1(inputs)
});
export { entity_isprivate1 as "entity_isPrivate" }